import './App.css';
import './config/amplify';
import { AuthProvider } from './hooks/useAuth';
import Router from './Router';
import { LanguageProvider } from './hooks/useLanguage';
import { EnvironmentProvider } from './providers/EnvironmentProvider';
import { TooltipProvider } from './components/ui/Tooltip';

function App() {
  return (
    <TooltipProvider>
      <LanguageProvider>
        <EnvironmentProvider>
          <AuthProvider>
            <Router />
          </AuthProvider>
        </EnvironmentProvider>
      </LanguageProvider>
    </TooltipProvider>
  );
}

export default App;
